import { Directive, HostListener } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
  // eslint-disable-next-line
  selector: 'input[type=file]',
  host: {
    '(change)': 'onChange($event.target.files)',
    '(blur)': 'onTouched()',
  },
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: FileValueAccessor, multi: true }],
  standalone: true
})
// https://github.com/angular/angular/issues/7341
export class FileValueAccessor implements ControlValueAccessor {
    @HostListener('change', ['$event.target.files']) onChange = (_: any) => { };
    @HostListener('blur') onTouched = () => { };

    writeValue(value: any) { }
    registerOnChange(fn: (_: any) => void) { this.onChange = fn; }
    registerOnTouched(fn: () => void) { this.onTouched = fn; }
}
